import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({ children, delay = 0, y = 40, className = "", ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.9, delay, ease: EASE }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const SectionLabel = ({ index, children, light = false }) => (
  <p className={`mb-6 flex items-center gap-3 text-xs font-bold uppercase tracking-[0.25em] ${light ? "text-[#BFD8EE]" : "text-[#09549F]"}`}>
    <span className={`inline-block h-px w-10 ${light ? "bg-[#BFD8EE]" : "bg-[#09549F]"}`} />
    {index} — {children}
  </p>
);

export const youtubeId = (url = "") => url.match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([\w-]{11})/)?.[1];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  else el.scrollIntoView({ behavior: "smooth" });
};
